import { SlButton } from 'src/components/BeaconV2Components/Header/SLDropdownMenu/SlButton';

import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import React, { useMemo } from 'react';
import colors from 'src/utils/colors';
import { validationSteps } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/constants';
import { PresentationsTabsPath } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/types';
import { useLocation } from 'src/utils/Hooks';
import { useSnackbar } from 'src/utils/Hooks';
import { useValidateDataset } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/hooks/useValidateDataset';
import { usePresentationFormContext } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/PresentationFormContext';
import { useBeaconNavigator } from 'src/components/BeaconV2Components/BeaconNavigation/useBeaconNavigator';

const BuilderFooter = () => {
  const { beaconNavigator } = useBeaconNavigator();
  const location = useLocation();
  const { showSnackbar } = useSnackbar();
  const { isValidStep, handleOnSubmit, isSubmitting } = usePresentationFormContext();

  const { isValidating: isValidatingDataset } = useValidateDataset();

  const handleNext = async () => {
    const isValid = isValidStep(location.pathname as PresentationsTabsPath);
    const validationStepsList = Object.keys(validationSteps);

    if (isValid) {
      if (location.pathname === PresentationsTabsPath.confirmations) {
        handleOnSubmit();
      } else {
        const nextStep = validationStepsList.findIndex((step) => step === location.pathname) + 1;
        beaconNavigator.setPathname(validationStepsList[nextStep]).go();
      }
    } else {
      showSnackbar({ type: 'error', message: validationSteps[location.pathname].error });
    }
  };

  const handleBack = () => {
    const validationStepsList = Object.keys(validationSteps);
    const currentIndex = validationStepsList.findIndex((step) => step === location.pathname);
    if (currentIndex > 0) {
      beaconNavigator.setPathname(validationStepsList[currentIndex - 1]).go();
    }
  };

  const getButtonTitle = () => {
    if (isValidatingDataset) {
      return 'Validating dataset...';
    }

    if (location.pathname === PresentationsTabsPath.confirmations) {
      return 'Submit';
    }

    return 'Next';
  };

  const isStepValid = useMemo(() => {
    return isValidStep(location.pathname as PresentationsTabsPath);
  }, [isValidStep, location.pathname]);

  if (location.pathname === PresentationsTabsPath.type) {
    return null;
  }

  return (
    <Flex
      justifyContent="space-between"
      sx={{ marginTop: '64px' }}
    >
      <SlButton
        buttonSx={{
          border: `1px solid ${colors.graysSecondary}`
        }}
        onClick={(e) => {
          e.preventDefault();
          handleBack();
        }}
        disabled={location.pathname === PresentationsTabsPath.type}
      >
        Back
      </SlButton>
      <SlButton
        variant="contained"
        buttonSx={{
          backgroundColor: !isValidatingDataset && isStepValid && !isSubmitting ? colors.darkBlue : colors.searchGrey,
          borderColor: !isValidatingDataset && isStepValid && !isSubmitting ? colors.darkBlue : colors.searchGrey
        }}
        textSx={{ color: colors.white }}
        onClick={(e) => {
          e.preventDefault();
          handleNext();
        }}
        disabled={isValidatingDataset || !isStepValid || isSubmitting}
      >
        {getButtonTitle()}
      </SlButton>
    </Flex>
  );
};

export default BuilderFooter;
